/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesh_Test_Connection_ErrorInputs */



/**
* | output |
* | --- |
* | "The connection with the server has stopped" |
*
* @param {Mesh_Test_Connection_ErrorInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const mesh_test_connection_error = /** @type {((inputs?: Mesh_Test_Connection_ErrorInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesh_Test_Connection_ErrorInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The connection with the server has stopped")
	return /** @type {LocalizedString} */ ("La connexion avec le serveur s'est interrompue")
});